import React from "react";

export function isFocusable(element: HTMLLIElement) {
  return (
    element.tabIndex >= 0 && element.getAttribute("aria-hidden") !== "true"
  );
}

export function getNextElement(
  currentElement: HTMLLIElement,
  menuRef: React.RefObject<HTMLUListElement>
) {
  if (menuRef && menuRef.current) {
    const children = Array.from(
      menuRef.current.querySelectorAll(":scope > li, :scope > div > li")
    ) as HTMLLIElement[];

    const index = children.indexOf(currentElement);

    for (let i = index + 1; i < children.length; i++) {
      if (isFocusable(children[i])) {
        return children[i];
      }
    }

    return children[0];
  }
}

export function getNextSubElement(
  currentElement: HTMLLIElement,
  menuRef: React.RefObject<HTMLUListElement>
) {
  if (menuRef && menuRef.current) {
    const children = Array.from(
      menuRef.current.querySelectorAll("li")
    ) as HTMLLIElement[];

    const index = children.indexOf(currentElement);

    for (let i = index + 1; i < children.length; i++) {
      if (isFocusable(children[i])) {
        return children[i];
      }
    }
  }
}

export function getPrevElement(
  currentElement: HTMLLIElement,
  menuRef: React.RefObject<HTMLUListElement>
) {
  if (menuRef && menuRef.current) {
    const children = Array.from(
      menuRef.current.querySelectorAll(":not(ul) li")
    ) as HTMLLIElement[];
    const index = children.indexOf(currentElement);

    for (let i = index - 1; i >= 0; i--) {
      if (isFocusable(children[i])) {
        return children[i];
      }
    }

    for (let i = children.length - 1; i >= index; i--) {
      if (isFocusable(children[i])) {
        return children[i];
      }
    }
  }
}

export function getNavigationElements(
  target: HTMLLIElement,
  menuRef: React.RefObject<HTMLUListElement>
) {
  const currentElement = target as HTMLLIElement &
    Partial<{ onClick: () => void; onPress: () => void }>;
  const nextElement = getNextElement(currentElement, menuRef) as HTMLLIElement;
  const prevElement = getPrevElement(currentElement, menuRef) as HTMLLIElement;
  const nextSubElement = getNextSubElement(
    currentElement,
    menuRef
  ) as HTMLLIElement;
  const parentElement = menuRef.current?.parentElement
    ?.firstChild as HTMLLIElement;

  return {
    currentElement,
    nextElement,
    prevElement,
    nextSubElement,
    parentElement,
  };
}
